import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HrGuardService implements CanActivate {
  constructor(private _auth: AuthService) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._auth.getToken().pipe(
      switchMap(() => {
        return this._auth.getUserRoles().pipe(
          map((e) => {
            return (e.corporateHrId && e.corporateHrId > 0) || (e.localHrId && e.localHrId > 0);
          })
        );
      })
    );
  }
}
